import { z } from 'zod';
import { createNumericKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { twoDiceSumSchema } from '../SharedZodSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
export var TileHexType = /*#__PURE__*/ function(TileHexType) {
    TileHexType[TileHexType["Desert"] = 0] = "Desert";
    TileHexType[TileHexType["Lumber"] = 1] = "Lumber";
    TileHexType[TileHexType["Brick"] = 2] = "Brick";
    TileHexType[TileHexType["Wool"] = 3] = "Wool";
    TileHexType[TileHexType["Grain"] = 4] = "Grain";
    TileHexType[TileHexType["Ore"] = 5] = "Ore";
    TileHexType[TileHexType["Gold"] = 6] = "Gold";
    TileHexType[TileHexType["Fog"] = 7] = "Fog";
    TileHexType[TileHexType["Sea"] = 8] = "Sea";
    return TileHexType;
}({});
export const fogOrDesertTileDiceNumber = 0;
export const tileHexDiceNumberSchema = z.union([
    z.literal(fogOrDesertTileDiceNumber),
    twoDiceSumSchema
]);
export const tileHexStateSchema = z.object({
    x: z.number().int().readonly(),
    y: z.number().int().readonly(),
    type: z.enum(TileHexType),
    diceNumber: tileHexDiceNumberSchema
}).strict();
export function validateTileHexState(data) {
    return validateState(tileHexStateSchema, data);
}
export const tileHexStatesSchema = createNumericKeyRecordSchema(tileHexStateSchema);
export function validateTileHexStates(data) {
    return validateState(tileHexStatesSchema, data);
}
export const tileHexStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(tileHexStateSchema);
export const tileHexStatesPartialSchema = createNumericKeyRecordSchema(tileHexStatePartialSchema, {
    requireAtLeastOneEntry: true
});
